"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  list: [],
  refs: [],
  show: function show() {},
  showOnly: function showOnly() {},
  showSuccess: function showSuccess() {},
  showError: function showError() {},
  showWarning: function showWarning() {},
  dismissAll: function dismissAll() {},
  dismissFirst: function dismissFirst() {},
  dismissLast: function dismissLast() {},
  dismissNth: function dismissNth() {}
});

exports.default = _default;